import { motion } from "framer-motion";
import { Star, Quote } from "lucide-react";

const REVIEWS = [
  {
    name: "Melissa T.", town: "Marietta", pkg: "Estate Package",
    text: "Justin came out, measured every inch, and his crew had our whole roofline glowing by dinner. A storm knocked a strand loose and they were back fixing it within a day. Zero hassle.",
  },
  {
    name: "Rachel & Doug H.", town: "Roswell", pkg: "Signature Package",
    text: "Alec walked us through every option and never once pushed the most expensive one. The crew was polite, quick, and the house looks like a Christmas postcard. January takedown was just as easy.",
  },
  {
    name: "Carla W.", town: "Woodstock", pkg: "Front Roof Line",
    text: "Third year with Southern Christmas Co. Justin remembers our house, our timer settings, everything. It's the best money we spend all year.",
  },
  {
    name: "Brian S.", town: "Alpharetta", pkg: "Front Roof Line",
    text: "The crew showed up on time, in and out in two hours, and our entryway looks incredible. Justin texted me photos before I even got home from work.",
  },
  {
    name: "Tanya M.", town: "Kennesaw", pkg: "Signature Package",
    text: "Alec noticed our front shrubs were perfect for net lights and suggested it without overselling. Half the street slows down to take pictures now. Great people, great company.",
  },
  {
    name: "Greg & Pam L.", town: "Canton", pkg: "Estate Package",
    text: "The crew treated our yard like their own, and Justin made sure every single bulb was warm white, exactly like the preview he showed us. Couldn't recommend them more.",
  },
];

export const Reviews = () => (
  <section id="reviews" className="mx-auto max-w-7xl px-5 py-24 sm:px-8 sm:py-32" data-testid="reviews-section">
    <motion.div
      initial={{ opacity: 0, y: 30 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-80px" }}
      transition={{ duration: 0.8 }}
      className="mb-14"
    >
      <p className="mb-4 font-mono-x text-xs uppercase tracking-[0.28em] text-amber-400">Word Around the Neighborhood</p>
      <h2 className="font-display max-w-2xl text-3xl font-bold tracking-tight text-amber-50 sm:text-5xl">
        Neighbors love <span className="italic text-amber-400">the glow.</span>
      </h2>
      <div className="mt-4 flex items-center gap-2">
        <span className="flex gap-0.5">
          {[...Array(5)].map((_, i) => (
            <Star key={i} size={16} className="fill-amber-400 text-amber-400" />
          ))}
        </span>
        <span className="font-mono-x text-[11px] uppercase tracking-[0.2em] text-emerald-100/60">5.0 from 120+ local homeowners</span>
      </div>
    </motion.div>

    <div className="grid gap-5 sm:grid-cols-2 lg:grid-cols-3">
      {REVIEWS.map((r, i) => (
        <motion.figure
          key={r.name}
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-60px" }}
          transition={{ duration: 0.7, delay: (i % 3) * 0.12 }}
          whileHover={{ y: -6 }}
          className={`relative overflow-hidden rounded-2xl border border-amber-500/15 bg-[#0B1D14]/80 p-7 transition-colors hover:border-amber-500/40 ${i % 2 === 1 ? "lg:mt-8" : ""}`}
          data-testid={`review-card-${i}`}
        >
          <Quote size={44} className="absolute -right-2 -top-2 text-amber-500/10" />
          <span className="flex gap-0.5">
            {[...Array(5)].map((_, s) => (
              <Star key={s} size={13} className="fill-amber-400 text-amber-400" />
            ))}
          </span>
          <blockquote className="mt-4 text-sm leading-relaxed text-emerald-100/85">"{r.text}"</blockquote>
          <figcaption className="mt-5 flex items-center justify-between border-t border-amber-500/10 pt-4">
            <div>
              <p className="text-sm font-bold text-amber-50">{r.name}</p>
              <p className="font-mono-x text-[10px] uppercase tracking-[0.2em] text-emerald-100/50">{r.town}, GA</p>
            </div>
            <span className="rounded-full border border-amber-500/25 px-3 py-1 font-mono-x text-[9px] uppercase tracking-widest text-amber-300/80">
              {r.pkg}
            </span>
          </figcaption>
        </motion.figure>
      ))}
    </div>
  </section>
);
